import React, { useState, useEffect } from 'react';
import Header from './Header.jsx';
// import './Header.css';
// import './Community.css'; 
import ProfileRanks from "./ProfileRanks.jsx";
import Default from '../assets/default_pfp.png';
import Discord from '../assets/discord.png';
import { Link } from 'react-router-dom';
import translations from './translation.js';

// TODO
// error messages for the form
// link should lead outside of the app
// add rankings

const FindPlayers = () => {
    const [description, setDescription] = useState('');
    const [discordLink, setDiscordLink] = useState('');
    const [username, setUsername] = useState("");
    const [userID, setUserID] = useState(null);
    const [members, setMembers] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
    const [descriptionError, setDescriptionError] = useState('');
    const [linkError, setLinkError] = useState('');
    const [val, setVal] = useState("");
    const handleValue = (val) => { setVal(val); };
    const [filteredMembers, setFilteredMembers] = useState([]);

    console.log(members)

    useEffect(() => {
        filterMembers();
    }, [val, members]);
    
    const filterMembers = () => {
        if (val !== null && val !== '' && val !== '@') {
            if  (val.startsWith('@')) {
                let filtered = members.filter(member => {
                    if (member.attributes && member.attributes.username) {
                        const usernameFilter = val.slice(1).toLowerCase();
                        return member.attributes.username.toLowerCase().includes(usernameFilter);
                    }
                    return false;
                });
                setFilteredMembers(filtered);
            }
        } else {
            setFilteredMembers(members);
        }
    };
    const [showCopyAlert, setShowCopyAlert] = useState(false);

    const handleButtonClick = () => {
        let descriptionError = '';
        let linkError = '';
    
        if (!description) {
          descriptionError = 'Description is required';
        }
    
        if (!discordLink) {
          linkError = 'Link is required';
        }
    
        setDescriptionError(descriptionError);
        setLinkError(linkError);
    
        if (description && discordLink) {
          console.log(`Description: ${description}`);
          console.log(`Discord Link: ${discordLink}`);
          addToFind();
          setDescription('');
          setDiscordLink('');
        }
      };

    const addToFind = async () => {
        try {
            const userResponse = await fetch(`${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem("user")}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            if (!userResponse.ok) {
                throw new Error('Failed to fetch user data');
            }

            const userData = await userResponse.json();
            const updatedAttributes = { ...userData.attributes, "find": true, "description": {description}, "discord": {discordLink}  };

            const patchResponse = await fetch(`${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem("user")}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    attributes: updatedAttributes,
                }),
            });

            if (!patchResponse.ok) {
                throw new Error('Failed');
            }

            const result = await patchResponse.json();
            console.log('updated successfully:', result);
        } catch (error) {
            console.error('Error updating:', error);
        }
    };

    const fetchUsersWithFind = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_PATH}/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
            });
    
            if (!response.ok) {
                throw new Error(`Failed to fetch users: ${response.status} ${response.statusText}`);
            }
    
            const responseData = await response.json();
    
            if (!Array.isArray(responseData) || responseData.length === 0) {
                throw new Error('Invalid response format: users array is missing or empty');
            }
    
            const usersArray = responseData[0];
    
            const usersWithFind = usersArray.filter(user => user.attributes && user.attributes.find === true);
    
            setMembers(usersWithFind);
            console.log(members);
    
        } catch (error) {
            console.error('Error fetching users:', error.message);
            alert(`Failed to fetch users: ${error.message}`);
        }
    };
    
    useEffect(() => {
        fetchUsersWithFind();
    }, []);

    const handleUsernameClick = (member) => {
        console.log('Clicked member:', member);
        setSelectedMember(member);
        console.log("the member clicked is")
        console.log(member)
    };

    const handleCopyDiscord = () => {
        if(selectedMember.attributes.discord?.discordLink === undefined){
            return
        }
        else{
            navigator.clipboard.writeText(selectedMember.attributes.discord?.discordLink)
            setShowCopyAlert(true)
        };
    }

    return (
        <div className="feed-container">
            <Header onValue={handleValue}/>
            <h1>{translations[currentLanguage].find}</h1>
            <div className="content-container">
            {/* <aside> */}
                    <div className='fp-info'>
                        <h2>{translations[currentLanguage].seek_player}</h2>
                        <br/>
                        <div style={{marginTop: "2%", overflow: "hidden" }}>
                            <div style={{maxHeight: "80vh", overflowY: "auto" }}>
                                {filteredMembers.map((member) => (
                                    <div 
                                        key={member.id} 
                                        style={{ backgroundColor: '#d1b140', padding: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center', borderRadius: '10px' }}
                                        onClick={() => handleUsernameClick(member)}
                                    >
                                        <img
                                            src={member.attributes.picture || Default}
                                            alt={member.attributes.username}
                                            style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '10px' }}
                                        />
                                        <span>
                                            @{member.attributes.username}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                {/* </aside> */}

 
                {/* <aside> */}
                    <div className='fp-info'>
                        <h2>{translations[currentLanguage].player_info}</h2>
                        <br/>
                        {selectedMember ? (
                            <>
                                <Link to={`/user/${selectedMember.id}`} style={{ textDecoration: 'none' }}>
                                    <img
                                        src={selectedMember.attributes.picture || Default}
                                        alt={selectedMember.attributes.username}
                                        style={{ width: '100px', height: '100px', borderRadius: '50%', marginBottom: '10px' }}
                                    />
                                </Link>
                                <span style={{ color: 'white', fontSize: '20px', fontFamily: 'Josefin Sans' }}>@{selectedMember.attributes.username}</span>
                                <p>
                                    <button 
                                        // href={selectedMember.attributes.discord?.discordLink} 
                                        className='find_button'
                                        onClick={handleCopyDiscord}
                                        style={{ display: 'block', marginTop: '10px' }}
                                    >
                                        <img 
                                            src={Discord} 
                                            alt="Discord Icon" 
                                            style={{ width: '24px', height: '24px', marginRight: '10px', verticalAlign: 'middle' }}
                                        />
                                        {selectedMember.attributes.discord?.discordLink}
                                    </button>
                                </p>
                                <br/>
                                <div className="yellow-box">
                                    <p>
                                        {selectedMember.attributes.description?.description}
                                    </p>
                                </div>
                                <h1 style={{fontSize:"18px"}}>{translations[currentLanguage].ranks}</h1>
                                <br/>
                                <ProfileRanks ranks={selectedMember.attributes.ranks} style='find'/>
                            </>
                        ) : (
                            <p style={{ color: 'white', fontSize: '16px', fontFamily: 'Josefin Sans' }}>
                                {translations[currentLanguage].player_info_text}
                            </p>
                        )}
                    </div>
                {/* </aside> */}

                {/* <aside> */}
                    <div className='fp-info'>
                        <h2>{translations[currentLanguage].looking_for}</h2>
                        <br />
                        <div className="yellow-box">
                            <p>
                                {translations[currentLanguage].looking_text1}
                            </p>
                        </div>
                        <label>
                            <textarea 
                                className="input1"
                                type="text" 
                                value={description}
                                placeholder={translations[currentLanguage].describle}
                                onChange={(e) => setDescription(e.target.value)} 
                            />
                        </label>
                        {descriptionError && <p className="RegisterForm_error">{descriptionError}</p>}
                        <br />
                        <div className="yellow-box">
                            <p>
                                {translations[currentLanguage].looking_text2}
                            </p>
                        </div>
                        <label>
                            <textarea 
                                className="input2"
                                type="text" 
                                value={discordLink}

                                placeholder={translations[currentLanguage].link}

                                onChange={(e) => setDiscordLink(e.target.value)} 
                            />
                        </label>
                        {linkError && <p className="RegisterForm_error">{linkError}</p>}
                        <br />
                        <button 
                            className='find_button' 
                            style={{marginTop: "2%", fontSize: "20px"}} 
                            onClick={handleButtonClick}
                        >
                            {translations[currentLanguage].submit}
                        </button>
                    </div>
                {/* </aside> */}
            </div>
            {showCopyAlert && 
                <div className="alert">
                    <span className="closebtn" onClick={() => setShowCopyAlert(false)}>&times;</span>
                    <strong>Copied To Clipboard</strong>
                </div>}
        </div>
    )
}

export default FindPlayers;
